import React, { useState, useEffect, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { Card, Alert } from "react-bootstrap";
import blogFetch from "../../axios/config";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import ReactiveButton from "reactive-button";
import { Button } from "@mui/material";
import "./QuestionSector.css";
import { getIdCompany } from "../../utils/constantes";
import "../../styles/Style.css";
import { useNavigate } from "react-router-dom";
import language from "../../nls/language.json";
import Context from "../../context/Context";

function QuestionSector() {
  
  const navigate = useNavigate();
  const [selectedValueSector, setSelectedValueSector] = useState(null);
  const [selectedValueShift, setSelectedValueShift] = useState(null);
  const [state, setState] = useState("idle");
  const [questionsector, setQuestionsector] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getQuestions();
  }, [selectedValueSector]);

  const addLogAuditAnswer = async () => {
    let logAduitAnsewrs = [];
    let data = new Date();
    let month = fmtDate0left(data.getMonth() + 1);
    let day = fmtDate0left(data.getDate());
    let year = data.getFullYear();
    let date = month.toString() + "-" + day.toString() + "-" + year.toString();

    for (let i = 0; i < questionsector.length; i++) {
      let answer = null;
      let answerOpen = null;
      if (questionsector[i].question.qeS_typeAnswer === 1) {
        answer = questionsector[i].answer;
      } else {
        answerOpen = questionsector[i].answer;
      }

      let obj = {
        LOA_date: date,
        LOA_answer: answer,
        LOA_answerOpen: answerOpen,
        LOA_FK_collaborator: 1,
        LOA_Fk_questionId: questionsector[i].question.qeS_PK_idQuestion,
        LOA_Fk_shiftId: selectedValueShift.sfT_PK_idShift,
        LOA_Fk_sectorId: selectedValueSector.stR_PK_idSector,
        LOA_FK_companyId: getIdCompany()
      };
      logAduitAnsewrs.push(obj);
    }

    try {
      let response = await blogFetch.post(
        "LogAuditAnswer/lote_",
        logAduitAnsewrs
      );

      const allQuestionsAnswered = questionsector.every(
        (question) => question.answer !== null
      );
  
      if (allQuestionsAnswered) {
        navigate("/dashboard");
      } else {
        setShowError(true);
        setErrorMessage("Por favor, responda todas as perguntas antes de salvar.");
      }
    } catch (error) {
      console.error("Erro ao enviar alterações para a API:", error);
    }
  };

  

  const fmtDate0left = (date) => {
    let newDate = date.toString();

    if (newDate.length == 1) {
      newDate = "0" + newDate;
    }

    return newDate;
  };

  const getSector = async () => {
    try {
      let response = await blogFetch.get("/sector");
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };
 

  const getShift = async () => {
    try {
      let response = await blogFetch.get("/shift");
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getQuestions = async () => {
    try {
      let response = await blogFetch.get(
        `/auditSector/sector_/${selectedValueSector.stR_PK_idSector}`
      );
      let data = response.data;
      let newData = data.map((item) => {
        const container = item;
        container["answer"] = null;
        return container;
      });
      setQuestionsector(newData);
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangeSector = (value) => {
    setSelectedValueSector(value);
  };

  const handleChangeShift = (value) => {
    setSelectedValueShift(value);
  };

  const split = (text, idQuestion) => {
    if (text == null || "") {
      return;
    }
    var newArray = text.split(";");
    var options = newArray.map((value) => ({ value: value, label: value }));
    return (
      <div>
        <Select
          options={options}
          id={idQuestion}
          onChange={handleChangeDefined(idQuestion)}
        />
      </div>
    );
  };

  const handleChange = (idQuestion, value) => {
    let newQuestion = questionsector.map((question) => {
      if (question.question.qeS_PK_idQuestion === idQuestion) {
        return { ...question, answer: value };
      } else {
        return question;
      }
    });
    setQuestionsector(newQuestion);
  };
  
  const handleChangeDefined = (idQuestion) => (event) => {
    let newQuestion = questionsector.map((question) => {
      if (question.question.qeS_PK_idQuestion === idQuestion) {
        return { ...question, answer: event.value };
      } else {
        return question;
      }
    });
    setQuestionsector(newQuestion);
  };
  
  const handleChangeOpen = (idQuestion) => (event) => {
    let newQuestion = questionsector.map((question) => {
      if (question.question.qeS_PK_idQuestion === idQuestion) {
        return { ...question, answer: event.target.value };
      } else {
        return question;
      }
    });
    setQuestionsector(newQuestion);
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        {/* Resto do código... */}
        {showError && (
          <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
            {errorMessage}
          </Alert>
        )}
        <div className="form-header">
          <h1 className="title_tables">{language[selectedCountry.name].Questionario.title}</h1>
          <p>{language[selectedCountry.name].Questionario.subTitle}</p>
        </div>

        <div className="async_selects">
          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Setor"
            value={selectedValueSector}
            getOptionLabel={(e) => e.stR_description}
            getOptionValue={(e) => e.stR_PK_idSector}
            loadOptions={getSector}
            onChange={handleChangeSector}
          />

          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Turno"
            value={selectedValueShift}
            getOptionLabel={(e) => e.sfT_description}
            getOptionValue={(e) => e.sfT_PK_idShift}
            loadOptions={getShift}
            onChange={handleChangeShift}
          />
        </div>
        <div className="questions_container">
        <div className="questions_container">
      {!!questionsector &&
        questionsector.map((questionItem) => (
          <Card
            className="question-card"
            key={questionItem.adS_PK_idAuditShift}
          >
            <Card.Title>{questionItem.question.qeS_description}</Card.Title>
            <Card.Body>
              {questionItem.question.qeS_typeAnswer === 1 && (
                <div className="button_group">
                  <Button
                    style={{
                      border: questionItem.answer ? "2px solid blue" : "2px solid black",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      margin: "5px",
                      backgroundColor: questionItem.answer ? "lightblue" : "transparent",
                    }}
                    onClick={() =>
                      handleChange(questionItem.question.qeS_PK_idQuestion, true)
                    }
                  >
                    Sim
                  </Button>
                  <Button
                    style={{
                      border: questionItem.answer === false ? "2px solid blue" : "2px solid black",
                      borderRadius: "5px",
                      padding: "5px 10px",
                      margin: "5px",
                      backgroundColor: questionItem.answer === false ? "lightblue" : "transparent",
                    }}
                    onClick={() =>
                      handleChange(questionItem.question.qeS_PK_idQuestion, false)
                    }
                  >
                    Não
                  </Button>
                </div>
              )}

              {questionItem.question.qeS_typeAnswer === 2 &&
                split(questionItem.question.qeS_possibleAnswer, questionItem.question.qeS_PK_idQuestion)}

              {questionItem.question.qeS_typeAnswer === 3 && (
                <input
                  type="text"
                  className="form-control"
                  id={questionItem.question.qeS_PK_idQuestion}
                  placeholder="Nome do Bloco"
                  onChange={handleChangeOpen(questionItem.question.qeS_PK_idQuestion)}
                />
              )}
            </Card.Body>
          </Card>
        ))}
    </div>
          
        </div>
        <div className="div_rounded_button">
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={addLogAuditAnswer}
            className="rounded_button"
          />
        </div>
      </div>
    </div>
  );
}
export default QuestionSector;
